import i18n from "i18next";
import languageDetector from "i18next-browser-languagedetector";
import resourcesToBackend from "i18next-resources-to-backend";
import { initReactI18next } from "react-i18next";
import Language from "./Language";

const inMemoryResourceBackend = resourcesToBackend(
  (language: string, namespace: string) =>
    import(`./locales/${language}/${namespace}.json`)
);

i18n
  .use(inMemoryResourceBackend)
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    nsSeparator: ":",
    detection: {
      order: ["querystring", "localStorage"],
      lookupQuerystring: "lang",
      caches: ["localStorage"],
    },
    fallbackLng: {
      EN_AR: [Language.ENGLISH],
      en_AR: [Language.ENGLISH],
      es_AR: [Language.SPANISH, Language.ENGLISH],
      es_MX: [Language.SPANISH, Language.ENGLISH],
      es_ES: [Language.SPANISH, Language.ENGLISH],
      pt_PT: [Language.PORTUGUESE, Language.ENGLISH],
      zh_CN: [Language.CHINESE, Language.ENGLISH],
      fr_CA: [Language.FRENCH, Language.ENGLISH],
      de_DE: [Language.GERMAN, Language.ENGLISH],
      it_IT: [Language.ITALIAN, Language.ENGLISH],
      pl_PL: [Language.POLISH, Language.ENGLISH],
      default: [Language.ENGLISH],
    },
  });

export default i18n;
